import React from 'react';
import AppLink from '../shared/AppLink';

const RestaurantsCard = ({ restaurant, className = "" }) => {
  const slugValue = typeof restaurant.slug === 'string'
    ? restaurant.slug
    : restaurant.slug?.current;
  const priceLabel = restaurant.priceRange || '';
  const serviceLabel = restaurant.serviceType || '';
  const areaLabel = restaurant.area || '';

  return (
    <div className={`flex flex-col h-full w-full min-w-0 max-w-[370px] mx-auto ${className}`}>
      <AppLink to={`/restaurants/${slugValue}`} className="block group h-full hover:text-green-300 transition-colors">
        <div className="border border-white/10 rounded-lg overflow-hidden">
          <div
            className="bg-white/5 p-3 flex items-center justify-center text-center"
            style={{
              height: '3.5em',
            }}
          >
            <h3 className="text-lg font-bold leading-tight">
              {restaurant.name}
            </h3>
          </div>
          
          <div className="bg-white/5 px-3 py-2 border-t border-white/10" style={{ height: '2.5em' }}>
            <div className="grid grid-cols-[auto_minmax(0,1fr)_minmax(0,1fr)] items-center gap-2 text-sm whitespace-nowrap h-full">
              <span className="min-w-0 truncate" title={priceLabel}>{priceLabel}</span>
              <span className="min-w-0 truncate text-center" title={serviceLabel}>{serviceLabel}</span>
              <span className="min-w-0 truncate text-right" title={areaLabel}>{areaLabel}</span>
            </div>
          </div>

          {restaurant.images?.[0]?.asset?.url && (
            <img
              src={restaurant.images[0].asset.url}
              alt={restaurant.name}
              className="w-full object-cover"
              style={{ height: '200px' }}
              loading="lazy"
            />
          )}
          
          <div className="bg-white/5 p-3 border-t border-white/10" style={{ height: '11em' }}>
            <p className="text-sm leading-tight overflow-hidden">
              {restaurant.shortDescription}
            </p>
          </div>
        </div>
      </AppLink>
    </div>
  );
};

export default RestaurantsCard;
